import { _wm } from './wmDateUtil';
import { _std } from './stdDateUtil';
import {
	STR_TMPT_LIST,
	DC_TMPT_LIST,
	STR_ORDER_LIST,
	OTH_ORD_FRCT_DT,
	OTIF_TMPT_LIST,
	WM_YR_WK_NO,
	STR_DEMAND_LIST,
	PURCHASE_ORDER_LIST,
	PO_DISABLE_CUSTOM_FUTURE_DATE,
	OMNI_TMPT_LIST,
	MUMD_ORDER_LIST,
	ECOM_INVENTORY,
	ECOM_SALES_LIST,
	LAST_WEEK,
	FUZZY_CALENDAR,
	WALMART_CALENDAR,
	GREGORIAN_CALENDAR,
	REGISTER_SALES_LIST,
	HISTORICAL_REPORT_OMNI
} from 'constants/constant';
import moment from 'moment';
import { format2Digit } from 'helper/helper';

export const getDateRange = (condition, forShrink = false, isWMTCal = false, isReport = false) => {
	const CURR_YR = moment().year();
	const PREV_YR = moment().subtract(1, 'year').year();
	const PREV_TO_PREV_YR = moment().subtract(2, 'year').year();

	let o = {
		Yesterday: _wm().yesterday,
		'Current Date': _wm().today,
		' Yesterday': isWMTCal ? _wm().yesterday : _std().yesterday,
		'WMT Week to date': (forShrink) => _wm().getWkToDate(forShrink),
		'WMT Month to date': (forShrink) => {
			return isReport ? _wm().getActualMonthToDate(forShrink) : _wm().getMonthToDate(forShrink);
		},
		'WMT Last week': (forShrink) => _wm().getLastXWkRange(1, forShrink),
		'WMT Last 2 weeks': (forShrink) => _wm().getLastXWkRange(2, forShrink),
		'WMT Last 4 weeks': (forShrink) => _wm().getLastXWkRange(4, forShrink),
		'WMT Last 13 weeks': (forShrink) => _wm().getLastXWkRange(13, forShrink),
		'WMT Last 26 weeks': (forShrink) => _wm().getLastXWkRange(26, forShrink),
		'WMT Last 52 weeks': (forShrink) => _wm().getLastXWkRange(52, forShrink),
		'WMT Last 104 weeks': (forShrink) => _wm().getLastXWkRange(104, forShrink),
		'WMT Quarter to date': (forShrink) => _wm().getQtrToDate(forShrink),
		'WMT Last quarter': (forShrink) => _wm().getLastXQtrRange(1, forShrink),
		'WMT Last 2 quarters': (forShrink) => _wm().getLastXQtrRange(2, forShrink),
		'WMT Last 4 quarters': (forShrink) => _wm().getLastXQtrRange(4, forShrink),
		'WMT Last Year': (forShrink) => _wm().getLastYrRange(forShrink),
		'WMT Last 6 years': (forShrink) => _wm().getLastXYearRange(6, forShrink),
		[`${CURR_YR} (WMT Year to date)`]: (forShrink) => _wm().getYrToDate(forShrink),
		[`${PREV_YR} (WMT Year to date)`]: (forShrink) => _wm().getYrToDate(forShrink),
		'WMT Year to date': (forShrink) => _wm().getYrToDate(forShrink),
		[`${PREV_YR}(WMT Year)`]: (forShrink) => _wm().getLastYrRange(forShrink),
		[`${PREV_TO_PREV_YR}(WMT Year)`]: (forShrink) => _wm().getLastYrRange(forShrink, true),
		'Current week': (forShrink) => _wm().getCurrWkDate(forShrink),
		'WMT Current week': (forShrink) => _wm().getCurrWkDate(forShrink),
		' WMT Current week': (forShrink) => _wm().getCurrWkDatev1(forShrink),
		'WMT Next week': (forShrink) => _wm().getNextXWkRange(1, forShrink),
		' WMT Next week': (forShrink) => _wm().getNextXWkRangev1(1, forShrink),
		'WMT Next 2 weeks': (forShrink) => _wm().getNextXWkRange(2, forShrink),
		'WMT Next 4 weeks': (forShrink) => _wm().getNextXWkRange(4, forShrink),
		' WMT Next 4 weeks': (forShrink) => _wm().getNextXWkRangev1(4, forShrink),
		'WMT Next 13 weeks': (forShrink) => _wm().getNextXWkRange(13, forShrink),
		' WMT Next 13 weeks': (forShrink) => _wm().getNextXWkRangev1(13, forShrink),
		'WMT Next 26 weeks': (forShrink) => _wm().getNextXWkRange(26, forShrink),
		' WMT Next 26 weeks': (forShrink) => _wm().getNextXWkRangev1(26, forShrink),
		'WMT Next 39 weeks': (forShrink) => _wm().getNextXWkRange(39, forShrink),
		' WMT Next 39 weeks': (forShrink) => _wm().getNextXWkRangev1(39, forShrink),
		' WMT Next 52 weeks': (forShrink) => _wm().getNextXWkRangev1(52, forShrink),
		'WMT Next 52 weeks': (forShrink) => _wm().getNextXWkRangev1(52, forShrink),
		' WMT Next 104 weeks': (forShrink) => _wm().getNextXWkRangev1(104, forShrink),
		'Week to date': (forShrink) => _std().getWkToDate(forShrink),
		'Last week': (forShrink) => {
			return isWMTCal ? _wm().getLastXWkRange(1, forShrink) : _std().getLastXWkRange(1, forShrink);
		},
		'Last 2 weeks': (forShrink) => {
			return isWMTCal ? _wm().getLastXWkRange(2, forShrink) : _std().getLastXWkRange(2, forShrink);
		},
		'Last 4 weeks': (forShrink) => {
			return isWMTCal ? _wm().getLastXWkRange(4, forShrink) : _std().getLastXWkRange(4, forShrink);
		},
		'Last 13 weeks': (forShrink) => {
			return isWMTCal
				? _wm().getLastXWkRange(13, forShrink)
				: _std().getLastXWkRange(13, forShrink);
		},
		'Last 26 weeks': (forShrink) => {
			return isWMTCal
				? _wm().getLastXWkRange(26, forShrink)
				: _std().getLastXWkRange(26, forShrink);
		},
		'Last 52 weeks': (forShrink) => {
			return isWMTCal
				? _wm().getLastXWkRange(52, forShrink)
				: _std().getLastXWkRange(52, forShrink);
		},
		'Last 104 weeks': (forShrink) => {
			return isWMTCal
				? _wm().getLastXWkRange(104, forShrink)
				: _std().getLastXWkRange(104, forShrink);
		},
		'Last 156 weeks': (forShrink) => {
			return isWMTCal
				? _wm().getLastXWkRange(156, forShrink)
				: _std().getLastXWkRange(156, forShrink);
		},
		'WMT LY Last 4 weeks': (forShrink) => _wm().getLastYearXWkRange(4, forShrink),
		'WMT LY Last 13 weeks': (forShrink) => _wm().getLastYearXWkRange(13, forShrink),
		'WMT LY Last 26 weeks': (forShrink) => _wm().getLastYearXWkRange(26, forShrink),
		'WMT LY Last 52 weeks': (forShrink) => _wm().getLastYearXWkRange(52, forShrink),
		'WMT LLY Last 4 weeks': (forShrink) => _wm().getLastLastYearXWkRange(4, forShrink),
		'WMT LLY Last 13 weeks': (forShrink) => _wm().getLastLastYearXWkRange(13, forShrink),
		'WMT LLY Last 26 weeks': (forShrink) => _wm().getLastLastYearXWkRange(26, forShrink),
		'WMT LLY Last 52 weeks': (forShrink) => _wm().getLastLastYearXWkRange(52, forShrink),

		'Month to date': (forShrink) => {
			if (isReport && isWMTCal) {
				return _wm().getActualMonthToDate(forShrink);
			}
			return isWMTCal ? _wm().getMonthToDate(forShrink) : _std().getMonthToDate(forShrink);
		},
		' Month to date': (forShrink) => _wm().getMonthToDate(forShrink),
		'Quarter to date': (forShrink) => _std().getQtrToDate(forShrink),
		'Last month': (forShrink) => {
			return isWMTCal
				? _wm().getLastXMonthRange(1, forShrink)
				: _std().getLastXMonthRange(1, forShrink);
		},
		'Last 2 months': (forShrink) => {
			return isWMTCal
				? _wm().getLastXMonthRange(2, forShrink)
				: _std().getLastXMonthRange(2, forShrink);
		},
		'Last 3 months': (forShrink) => {
			return isWMTCal
				? _wm().getLastXMonthRange(3, forShrink)
				: _std().getLastXMonthRange(3, forShrink);
		},
		'Last 6 months': (forShrink) => {
			return isWMTCal
				? _wm().getLastXMonthRange(6, forShrink)
				: _std().getLastXMonthRange(6, forShrink);
		},
		'Last 12 months': (forShrink) => {
			return isWMTCal
				? _wm().getLastXMonthRange(12, forShrink)
				: _std().getLastXMonthRange(12, forShrink);
		},
		'Last quarter': (forShrink) => _std().getLastXQtrRange(1, forShrink),
		'Last 2 quarters': (forShrink) => _std().getLastXQtrRange(2, forShrink),
		'Last 4 quarters': (forShrink) => _std().getLastXQtrRange(4, forShrink),
		[`${CURR_YR} (Year to date)`]: (forShrink) => _std().getYrToDate(forShrink),
		[`${PREV_YR}`]: (forShrink) => _std().getLastYrRange(forShrink),
		'Last Weekend [Fri-Sat-Sun]': (forShrink) => _wm().getWeekendRange(forShrink),
		'Next 2 weeks': (forShrink) => _wm().getNextXWkRange(2, forShrink),
		'Next 4 weeks': (forShrink) => _wm().getNextXWkRange(4, forShrink),
		'Next 13 weeks': (forShrink) => _wm().getNextXWkRange(13, forShrink),
		'Next 26 weeks': (forShrink) => _wm().getNextXWkRange(26, forShrink),
		'Next 52 weeks': (forShrink) => _wm().getNextXWkRange(52, forShrink)
	};
	// In the case of MTS and when the user selects only custom dates, o[condition] returns undefined
	if (!o?.[condition]) {
		return '';
	}
	return o[condition](forShrink);
};

moment.updateLocale('wm', {
	week: {
		dow: 6
	}
});

export const getMinMax = (
	templateId,
	calMember = false,
	forWeek,
	bussName,
	isMTSCalendar = false,
	showWalCal
) => {
	/**
	 * For MTS, Calendar should be restricted to 52 Weeks
	 */
	if (isMTSCalendar) {
		return {
			min: moment().clone().subtract(52, 'week').startOf('week'),
			max: moment().clone().endOf('day')
		};
	}
	const templateList = [...STR_TMPT_LIST, ...DC_TMPT_LIST];
	const strOrderList = [...STR_ORDER_LIST];
	let max = moment().clone().subtract(1, 'day').endOf('day');
	let min = moment().clone().subtract(1, 'year').startOf('day');

	if (!calMember) {
		if (OTH_ORD_FRCT_DT.includes(bussName)) {
			max = moment().clone().add(26, 'week').endOf('week');
			min = moment().clone().endOf('day');
		} else {
			if (bussName === WM_YR_WK_NO) {
				min = moment().clone().add(1, 'week').startOf('week');
				max = moment().clone().add(104, 'week').startOf('week');
			} else {
				min = moment().clone().subtract(26, 'year').startOf('day');
			}
		}

		return { min, max };
	}

	if (templateList.includes(Number(templateId))) {
		if (forWeek) {
			max = moment().clone().subtract(1, 'week').endOf('week');
			min = moment().clone().subtract(52, 'week').startOf('week');
		} else {
			if (STR_TMPT_LIST.includes(Number(templateId))) {
				min = moment().clone().subtract(52, 'week').startOf('week');
			} else {
				// dc template
				min = moment().clone().subtract(31, 'days').startOf('day');
			}
		}
	} else if (strOrderList.includes(Number(templateId))) {
		min = moment().clone().subtract(26, 'week').startOf('week');
		max = moment().clone().endOf('day');
	} else if (OTIF_TMPT_LIST.includes(Number(templateId))) {
		max = moment().clone().subtract(2, 'week').endOf('week');
	} else if (STR_DEMAND_LIST.includes(Number(templateId))) {
		max = moment().clone().subtract(1, 'week').endOf('week');
		min = moment().clone().subtract(4, 'week').endOf('week');
	} else if (PURCHASE_ORDER_LIST.includes(Number(templateId))) {
		min = moment().clone().subtract(1, 'year').startOf('week');
		max = moment().clone().add(1, 'year').endOf('week');
		if (PO_DISABLE_CUSTOM_FUTURE_DATE.includes(bussName)) {
			min = moment().clone().subtract(1, 'year').startOf('week');
			max = moment().clone().add(1, 'day').endOf('week');
		}
	} else if (HISTORICAL_REPORT_OMNI.includes(Number(templateId))) {
		min = moment().clone().subtract(6, 'year').startOf('week');
		max = moment().clone().add(1, 'year').endOf('week');
	}

	// Allow future date selection
	if (
		OMNI_TMPT_LIST.includes(Number(templateId)) ||
		OTIF_TMPT_LIST.includes(Number(templateId)) ||
		STR_TMPT_LIST.includes(Number(templateId)) ||
		DC_TMPT_LIST.includes(Number(templateId)) ||
		MUMD_ORDER_LIST.includes(Number(templateId)) ||
		ECOM_INVENTORY.includes(Number(templateId))
	) {
		max = moment().clone().add(1, 'year').endOf('week');
	}

	// 104 weeks feature - Custom week going till last 104 weeks - enabled only for SSI, DC, MUMD, Omni Sales, Register Sales, Ecom Sales and Ecom Inventory
	// Conditions applied: week custom filter only, has to be walmart calendar and not gregorian and finally the aforementioned templates only
	const customDate104WeeksTmpls = [
		...STR_TMPT_LIST,
		...DC_TMPT_LIST,
		...MUMD_ORDER_LIST,
		...OMNI_TMPT_LIST,
		...ECOM_INVENTORY,
		...ECOM_SALES_LIST,
		...REGISTER_SALES_LIST
	];
	if (forWeek && customDate104WeeksTmpls.includes(Number(templateId)) && showWalCal) {
		min = moment().clone().subtract(104, 'week').endOf('week');
	}

	return { min, max };
};

export const getMutlipleDateRange = (condition) => {
	const o = {
		// 'WMT Last week': '_lastweek',
		// 'WMT Last 2 weeks': '_last2week',
		// 'WMT Last 4 weeks': '_last4week',
		// 'WMT Last 13 weeks': '_last13week',
		// 'WMT Last 26 weeks': '_last26week',
		// 'WMT Last 52 weeks': '_last52week'
		'WMT Last week': '1300-01-01',
		'WMT Last 2 weeks': '1400-01-01',
		'WMT Last 4 weeks': '1500-01-01',
		'WMT Last 13 weeks': '1600-01-01',
		'WMT Last 26 weeks': '1700-01-01',
		'WMT Last 52 weeks': '1800-01-01'
	};
	return o[condition];
};

export const wkDayRange = (x) => {
	let start = moment().clone().subtract(x, 'week').startOf('week');
	let end = moment().clone().subtract(x, 'week').endOf('week');
	return [start, end];
};

export const getRequestedNoOfWeeks = (condition) => {
	const o = {
		'WMT Last week': 1,
		'WMT Last 2 weeks': 2,
		'WMT Last 4 weeks': 4,
		'WMT Last 13 weeks': 13,
		'WMT Last 26 weeks': 26,
		'WMT Last 52 weeks': 52
	};
	return o[condition];
};

export const getConditionFieldFromWeek = (weekNum) => {
	if (weekNum === 0) {
		return '';
	}
	if (weekNum === 1) {
		return 'WMT Last week';
	}
	return `WMT Last ${weekNum} weeks`;
};

export const getWKWithYrRange = (yr, wk) => {
	const startYear = Number(yr[0].split('/')[0]);
	const endYear = Number(yr[1].split('/')[0]);
	const v1 = `${moment(yr[0]).year()}${format2Digit.format(wk[0])}`;
	const v2 = `${moment(yr[1]).year()}${format2Digit.format(wk[1])}`;
	if (startYear != undefined && endYear != undefined && endYear > startYear) {
		const lastWeek = `${moment(yr[0]).year()}${LAST_WEEK}`;
		return `${lastWeek} to ${v2}`;
	}
	return `${v1} to ${v2}`;
};

/**
 * This would give the difference between two dates, in a specified way
 * date1 = '08/24/2024'
 * date2 = '09/20/2024'
 *
 * Then result would be 27. (in days)
 */
export const getDateDifference = (date1, date2, diffIn = 'days') => {
	let result = 0;
	if (moment.isDate(date1) && moment.isDate(date2)) {
		const d1 = moment(date1);
		const d2 = moment(date2);
		result = d2.diff(d1, diffIn);
	}
	return result;
};

export const getStartAndEndDates = (
	condition,
	fuzzyOptions,
	isWalmartCalender,
	calendarRollDim
) => {
	const timeFrame = fuzzyOptions[condition];
	const calendarType = isWalmartCalender
		? FUZZY_CALENDAR[WALMART_CALENDAR]
		: FUZZY_CALENDAR[GREGORIAN_CALENDAR];
	const filteredFuzzyOption = calendarRollDim?.find(
		(fuzzyOption) =>
			fuzzyOption.timeframe === timeFrame && fuzzyOption.calendarType === calendarType
	);
	return filteredFuzzyOption;
};
